/*
 * The back office's searches (a company's name, a course's title) happen in the page, over what
 * the screen already shows: what is typed is never sent to the server, nor kept in the address
 * or in the audit trail (ADR 0008 §5).
 */

/** The longest search kept: more than any name or title needs. */
export const SEARCH_MAX = 100

/**
 * Text as it is compared: without accents, case or extra spaces, so that "comunicacion" finds
 * «Comunicación».
 */
export function foldForSearch(text: string, locale: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/\s+/gu, ' ')
    .trim()
    .toLocaleLowerCase(locale)
}

/** Whether `text` contains every word of `search` (already folded), in any order. */
export function matchesSearch(text: string, search: string, locale: string): boolean {
  if (!search) return true
  const folded = foldForSearch(text, locale)
  return search.split(' ').every((word) => folded.includes(word))
}
